const registry = require('../registry');

// TabNavLayout is special in that it's direct children are tabs
// However, that is built-in to the standard hNode extractAccess function
// Just adding this file to draw attention to that fact and avoid future confusion.
const layouts = {
    TabViewLayout: { extractAccess: registry.hNode.extractAccess }
};
registry.register('layouts', layouts);
module.exports = layouts;
